const resetPasswordFormConstantsEN = {
  resetPasswordFormTitle: 'Create a new password',
  resetPasswordSubFormTitle: 'Please create and verify a new secure password for your account.',
  resetPasswordFormButtonText: 'Continue',
  resetPasswordFormPasswordLabel: 'Password',
  resetPasswordFormConfirmPasswordLabel: 'Confirm Password',
  linkExpiredText: 'The link has expired',
};

export default resetPasswordFormConstantsEN;
